<template>
  <v-row>
    <v-col class="d-block pt-0" cols="12" v-for="alert in upgradepromotions" :key="alert.id">
      <v-alert
        color="primary"
        class="py-3 px-1 mb-0"
        role="note"
      >
        <template v-slot:prepend>
          <v-icon size="24" class="mx-2 d-none d-sm-block" color="#ffd859">mdi-star</v-icon>
        </template>
        <div class="d-flex justify-space-between align-center">
          <div>
            <div class="text-white font-weight-bold">{{ alert.name }}</div>
            <div class="text-white">{{ alert.description }}</div>
          </div>
          <gg-btn
            color="primary"
            class="mr-md-2"
            elevation="4"
            :to="{ name: 'hosting_create_request', params: { path: alert.path, hostingid: alert.service_id } }"
            role="link"
          >
            View Promotion
          </gg-btn>
        </div>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PromotionBanners',
  computed: {
    ...mapGetters({
      upgradepromotions: 'upgradepromotions',
    }),
  }
}
</script>

<style scoped>

</style>
